import { render, staticRenderFns } from "./LoadingPhotos.vue?vue&type=template&id=9828bb94&"
import script from "./LoadingPhotos.vue?vue&type=script&lang=js&"
export * from "./LoadingPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports